<template>
    <div>
        <div style="display: flex; justify-content: space-between; align-items: center;"   >
            <primary-title id="title-wishlist">Lista de desejos</primary-title>
             <div style="display: flex; justify-content: flex-end; align-items: center;">
                <c-button
                    :backgroundColor="$root.$children[0].theme.products.button.background_color"
                    :backgroundColorHover="$root.$children[0].theme.products.button.background_color_hover"
                    :color="$root.$children[0].theme.products.button.color"
                    :colorHover="$root.$children[0].theme.products.button.color_hover"
                    :borderColor="$root.$children[0].theme.products.button.border_color"
                    :borderColorHover="$root.$children[0].theme.products.button.border_color_hover"
                    :borderRadius="$root.$children[0].theme.products.button.border_radius"
                    :textTransform="$root.$children[0].theme.products.button.text_transform"
                    display="flex"
                    padding="0.2rem 1.8rem"
                    @click.stop="removeAllItemsWishList()"
                    aria-label="Remover todos os produtos da lista de desejos"

                >
                <i class="fas fa-trash-alt"></i>
                    Remover Todos
                </c-button>

                <c-button
                    :backgroundColor="$root.$children[0].theme.products.button.background_color"
                    :backgroundColorHover="$root.$children[0].theme.products.button.background_color_hover"
                    :color="$root.$children[0].theme.products.button.color"
                    :colorHover="$root.$children[0].theme.products.button.color_hover"
                    :borderColor="$root.$children[0].theme.products.button.border_color"
                    :borderColorHover="$root.$children[0].theme.products.button.border_color_hover"
                    :borderRadius="$root.$children[0].theme.products.button.border_radius"
                    :textTransform="$root.$children[0].theme.products.button.text_transform"
                    display="inline-flex"
                    padding="0.2rem 1.8rem"
                    @click.stop="saveWishlistLink()"
                    aria-label="Salvar link da lista"
                >
                    <i class="fas fa-link" style="" ></i>
                    Compartilhar
                </c-button>
            </div>
        </div>

        <div class="mb-4"></div>

        <div class="product-intro row row-sm">
            <LoadingApp
                :is_full_page="true"
                :isLoading="isLoading"
            />
            <template v-if="itemsWishlist.length">
                <template v-for="item in itemsWishlist">
                    <ProductDefault
                        :key="item.id"
                        :pro="item"
                        layout_mode="list"
                        :page_wish_list="true"
                        :products_settings="products_settings"
                        @updateList="updateList"
                    >
                    </ProductDefault>
                </template>
            </template>
            <template v-else>
                <div
                    class="col-md-12"
                    style="display:flex; align-items:center;justify-content:center"
                >
                    <h3 style="color:#DB1;">
                        Sua lista de desejos esta vazia :(
                    </h3>
                </div>
            </template>
        </div>

        <Pagination
            :source="pagination"
            @navigate="navigate"
            :pagination_range="6"
        />
    </div>
</template>

<script>
import { CPrimaryTitle } from "../../components/Styles/Components/styled";
import ProductDefault from "../../components/product/ProductDefault.vue";
import { mapActions, mapState } from 'vuex';
import Pagination from '../../components/Pagination.vue'
import LoadingApp from '../../components/LoadingApp.vue'
import { CButton } from '../../components/Styles/Button/styled';
import { swall } from '../../services/sweetAlert'


export default {
    name: "Wishlist",
    props: {
        // products_settings: {
        //     default: null,
        //     required: true,
        // },
        user:{
            default: null,
            required: false,
        }
    },
    
    components: {
        'c-button': CButton,
        ProductDefault,
        Pagination,
        LoadingApp,
        'primary-title': CPrimaryTitle
    },
    data() {
        return {
            isLoading: false,
            page: 1,
        }
    },
    mounted() {
        this.getList()
    },
    methods: {
        ...mapActions("wishlist", [
            "getListPaginate",
            "setItemsWishlist",
            "setPagination",
            "ActionRemoveAllItemsWishList"
        ]),
        async removeAllItemsWishList() {
            await this.ActionRemoveAllItemsWishList()
            this.updateList()
            swall('Todos os produtos foram removidos da lista de desejos!', false, "check", "success", 3)   
        },

        navigate(page = this.page) {
            this.page = page
            this.getList()
            let titleWishlist = document.querySelector('#title-wishlist')
            let sectionTitleWishlist = titleWishlist.getBoundingClientRect()
            window.scroll(0, sectionTitleWishlist.top + scrollY - titleWishlist.offsetHeight)
        },
        getList() {
            this.isLoading = true
            let filters = this.getFilters()

            this.getListPaginate(filters)
            .then(response => {
                this.isLoading = false
                this.setItemsWishlist(response.data.data)
                this.setPagination(response.data)
            })
            .catch(error => {
                this.isLoading = false
                console.log(error)
            })
        },
        async saveWishlistLink() {
            const id = this.user?.data?.id ?? null

            if (!id) {
                swall('ID do usuário não encontrado.', true, "times", "error", 3)
                return
            }

            const origin = (window?.location?.origin) || ''

            const link = `${origin}/wishlist/${id}`


            if (navigator?.clipboard?.writeText) {
                navigator.clipboard.writeText(link).catch(()=>{})
            }

            swall(`Copiado ! `, false, "check", "success", 3)

        },

        getFilters() {
            return {
                page: this.page
            }
        },
        updateList() {
            if(this.itemsWishlist.length == 1 && this.page > 1) {
                this.page--
            }
            this.getList()
        }
    },
    computed: {
        ...mapState("wishlist", [
            "itemsWishlist",
            "pagination",
        ]),
        products_settings() {
            return this.$root.$children[0].$attrs.company?.products_settings ?? null
        }
    }
};
</script>
